import React, { useEffect, useState } from "react";
import axios from "axios";

const Logs = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetchLogs();
    const i = setInterval(fetchLogs, 3000);
    return () => clearInterval(i);
  }, []);

  const fetchLogs = async () => {
    const res = await axios.get(
      process.env.REACT_APP_BACKEND + "/logs?limit=300",
    );
    setLogs(res.data);
  };

  return (
    <div style={{ background: "#000", color: "#0f0", padding: 12 }}>
      {logs.map((log, i) => (
        <pre key={i}>{log}</pre>
      ))}
    </div>
  );
};

export default Logs;
